import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Picture = (props) => {
    if (props.url) {
        return (_jsx("img", { className: "av-profile-image rounded-circle", src: props.url, alt: props.person.fullName }));
    }
    return (_jsxs("div", { className: "av-profile-image rounded-circle d-flex justify-content-center flex-column", style: { backgroundColor: props.person.initialsBackgroundColorHex }, children: [props.person.firstName[0], props.person.lastName[0]] }));
};
const ProfilePicture = (props) => {
    // set url to null if showProfilePicture is false, otherwise return photoUrl or smallPhotoUrl if photoUrl is undefined.
    const url = props.showProfilePicture
        ? props.photoUrl || props.person.smallPhotoUrl
        : null;
    if (props.profileUrl) {
        return (_jsx("a", { href: props.profileUrl, children: _jsx(Picture, { person: props.person, url: url }) }));
    }
    return _jsx(Picture, { person: props.person, url: url });
};
export default ProfilePicture;
